import React from 'react';

import styled from 'styled-components';
import type { TextFieldProps } from './types';

const TextField = ({
  helperText,
  className = '',
  placeholder,
  value,
  isMobile,
}: TextFieldProps) => (
  <StyledTextField className={className}>
    <StyledLabel>
      <Input isMobile={isMobile} placeholder={placeholder} value={value} />
    </StyledLabel>
    {helperText && <StyledHelperText>{helperText}</StyledHelperText>}
  </StyledTextField>
);

const StyledTextField = styled.div`
  text-align: left;
  margin-bottom: 20px;
  display: inline-flex;
  flex-direction: column;
`;

const StyledLabel = styled.label`
  margin-bottom: 3px;
  display: flex;
  font-size: 9px;
  text-transform: uppercase;
  color: #4d4d4d;
  width: 100%;
`;

const StyledHelperText = styled.span`
  display: block;
  font-size: 12px;
  color: #919499;
  margin-top: 3px;
`;

const Input = styled.input<{ isMobile: boolean }>`
  border-radius: 4px;
  border: solid 1px #c2c5cc;
  background-color: #fff;
  font-weight: bold;
  padding: 15px 8px;
  box-sizing: border-box;
  width: 100%;
  font-size: ${({ isMobile }) => (isMobile ? '13' : '14')}px;
  &:disabled {
    opacity: 0.6;
  }

  &::placeholder {
    color: #919499;
    font-weight: normal;
  }
`;

export default TextField;
